import { render } from "./TypographyDiscoverMode.vue?vue&type=template&id=5c83efd0"
import script from "./TypographyDiscoverMode.vue?vue&type=script&lang=js"
export * from "./TypographyDiscoverMode.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\1\\s\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__